import { createFileRoute, redirect } from '@tanstack/react-router';
import { EmployeeSettings } from '../components/EmployeeSettings';
import { isAdmin } from '../utils/roles';

export const Route = createFileRoute('/settings/employees')({
  beforeLoad: ({ context }) => {
    const { user } = context.auth;
    if (!isAdmin(user?.role)) {
      throw redirect({
        to: '/project-settings/employee-project-models',
      });
    }
  },
  component: EmployeeSettingsComponent,
});

function EmployeeSettingsComponent() {
  return <EmployeeSettings />;
}
